import React from "react";
import { useFormik } from "formik";
import { Image } from "primereact/image";
import { Link } from "react-router-dom";

import { toast } from "react-toastify";

// logo
import logo from "../../assets/logo.svg";
import eca from "../../assets/eca.png";
import unu from "../../assets/unu.png";

// customs
import ButtonGroup from "../../components/forms/ButtonGroup";
import EnterpreneurRegistrationForm from "../../components/forms/EnterpreneurRegistrationForm";
import InvestorRegistrationForm from "../../components/forms/InvestorRegistrationForm";
import PolicyMakerRegistrationForm from "../../components/forms/PolicyMakerRegistrationForm";
import { USERTYPE } from "../../constants/USERTYPE";
import { Translate } from "react-auto-translate";

export default function RegisterPage(props) {
  const [selected, setSelected] = React.useState(USERTYPE.ENTREPRENEUR);

  return (
    <main className="relative overflow-y-scroll">
      <div className="relative flex">
        <div className="h-full col-12 lg:col-6 p-3 md:p-5 lg:py-8 flex flex-column">
          <div className="w-12 md:w-10 lg:w-9 align-self-center">
            <div className="mt-3">
              <Image src={logo} imageClassName="h-2rem md:h-3rem" />
            </div>
            <div className="flex flex-column mt-5 text-3xl md:text-5xl">
              <strong>
                <Translate>Sign up for the JUSTIS</Translate>
              </strong>
              <strong>
                <Translate>Social Portal</Translate>
              </strong>
            </div>

            <p className="text-base md:text-lg lg:text-xl mt-5">
              <Translate>Sign up as</Translate>
            </p>
            <ButtonGroup
              selected={selected}
              onButtonOneClick={() => setSelected(USERTYPE.ENTREPRENEUR)}
              onButtonTwoClick={() => setSelected(USERTYPE.POLICY_MAKER)}
              onButtonThreeClick={() => setSelected(USERTYPE.INVESTOR)}
            />

            {selected === USERTYPE.ENTREPRENEUR ? (
              <EnterpreneurRegistrationForm />
            ) : selected === USERTYPE.POLICY_MAKER ? (
              <PolicyMakerRegistrationForm />
            ) : (
              <InvestorRegistrationForm />
            )}

            <div>
              <Link
                to="/"
                className="no-underline text-md md:text-lg text-primary-800  hover:text-primary-600"
              >
                <p className="text-md m-0 ">
                  <Translate>Need an account? Sign up here</Translate>
                </p>
              </Link>
            </div>
          </div>
        </div>
        <div className="h-auto flex-auto hidden lg:flex flex-column login-image justify-content-end">
          <div className="p-7 login w-10 align-self-center mb-5">
            <div>
              <strong className="text-white text-4xl">
                <Translate>
                  Connect, engage and unlock potential investments
                </Translate>
              </strong>
            </div>

            <div>
              <p className="text-lg text-white font-medium">
                <Translate>
                  The JUSTIS digital portal seeks to bridge the gap between
                  green entrepreneurs, policymakers, and investors to accelerate
                  green growth and green transitions.
                </Translate>
              </p>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}
